import React from "react";
import I1 from "../../Images/New/RightSoft/1.png";
import I2 from "../../Images/New/RightSoft/2.png";
import I3 from "../../Images/New/RightSoft/3.png";
import I4 from "../../Images/New/RightSoft/4.png";
import I5 from "../../Images/New/RightSoft/5.png";

function Anylise() {
  const [expandedIndex, setExpandedIndex] = React.useState(-1);

  const handleClick = (index) => {
    if (expandedIndex === index) {
      setExpandedIndex(-1);
    } else {
      setExpandedIndex(index);
    }
  };

  let ListItem = React.memo(({ text }) => (
    <li className="flex gap-x-3 items-start text-xl">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#00b812"
        class="bi bi-caret-right-fill"
        viewBox="0 0 16 16"
        className="mt-[6px] mx-4 w-[16px] h-[16px]"
      >
        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
      </svg>
      <span>
        <strong className="font-semibold text-gray-900"> {text} </strong>
      </span>
    </li>
  ));

  const faqDataLeft = [
    {
      question: "Certificate Register",
      answer: [
        "Allows users to keep track of all the TDS and TCS certificates generated and issued. It includes information such as PAN numbers, dates of issue, Deductee names and TDS/TCS amounts.",
      ],
      img: I1,
    },
    {
      question: "Challan Register",
      answer: [
        "A record of all the challans created and used for TDS and TCS payments. Information such as challan serial numbers, Dates, bank names, and payment amounts can be easily accessed and viewed.",
      ],
      img: I2,
    },
    {
      question: "Transaction Register",
      answer: [
        "Challan wise, TDS Section wise, Deductee wise, Employee wise detail Report",
      ],
      img: I3,
    },
    {
      question: "Return filled Information register",
      answer: [
        "Information of all the TDS and TCS returns that have been filed through the software. Users can easily access and view details such as return acknowledgment numbers, dates of filing and the status of the return on a click.",
      ],
      img: I4,
    },
    {
      question: "Deductors, Deductees & Employees Register",
      answer: [
        "Contains a comprehensive list of all the Deductors, Deductees & employees. Information such as names, addresses and labels can be easily accessed & viewed.",
      ],
      img: I5,
    },
  ];

  return (
    <div className="sm:flex py-20 sm:px-10 bg-[#f1f5f8] relative items-center">
      <div className="w-full sm:px-5 flex justify-center">
        <div className="bg-white flex-col sm:flex items-center border-2 rounded-2xl shadow-xl px-1 sm:px-12 py-10 w-full max-w-7xl">
          <div className="flex flex-col justify-center text-center items-center mb-5">
            <h2 className="font-bold text-5xl tracking-tight">
              <span
                className="font-extrabold"
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #686bff 0%, #00b812 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                Reports & Analysis
              </span>{" "}
            </h2>
          </div>
          <div className="grid grid-cols-1 items-start px-3 sm:px-0 w-full gap-4 ">
            {faqDataLeft.map((faq, index) => (
              <div
                key={index}
                className={`faq-item bg-white border-2 rounded-xl overflow-hidden ${
                  expandedIndex === index ? "border-[#b5d0ff]" : ""
                }`}
              >
                <summary
                  className="flex justify-between text-2xl items-center font-medium cursor-pointer list-none bg-white p-4"
                  onClick={() => handleClick(index)}
                >
                  <span className="flex items-center">
                    <img className="h-8 w-8 mr-5" src={faq.img} alt="" />
                    <span>{faq.question}</span>
                  </span>
                  <span className="transition bg-[#b5d0ff] rounded-full p-2">
                    <svg
                      fill="none"
                      shapeRendering="geometricPrecision"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      className="w-[24px] h-[24px]"
                    >
                      <path d="M6 9l6 6 6-6"></path>
                    </svg>
                  </span>
                </summary>
                {expandedIndex === index && (
                  <div className="answer p-4 bg-white">
                    {faq.answer.map((item, idx) => (
                      <ListItem key={idx} text={item} />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Anylise;
